<template>
<div>
  <v-app>
    <v-content>
      <div id="mapcontainer">
        <div id="map" ></div>
      </div>
      <Index ref="index"></Index>
    </v-content>
  </v-app>
    <legends ref="legendsPane" ></legends>
  </div>
</template>

<script>
import Index from './components/Index';
import Legends from '@/components/Legends'


export default {
  name: 'App',

  mounted () {
    this.$store.legends = this.$refs.legendsPane
  },
  components: {
    Index,
    'legends':Legends
  },
};
</script>
